import { ReactNode } from "react";

export function TableText({
  children,
  className = "",
  title = undefined,
}: {
  children: ReactNode;
  className?: string;
  title?: string;
}) {
  return (
    <p className={`text-sm text-persian-990 ${className}`} title={title}>
      {children}
    </p>
  );
}
